import { render, staticRenderFns } from "./AdminNoteItem.vue?vue&type=template&id=3a38a6d8&scoped=true"
import script from "./AdminNoteItem.vue?vue&type=script&lang=js"
export * from "./AdminNoteItem.vue?vue&type=script&lang=js"
import style0 from "./AdminNoteItem.vue?vue&type=style&index=0&id=3a38a6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38a6d8",
  null
  
)

export default component.exports